import {
  gsap
} from 'gsap'

import {
  ScrollTrigger
} from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default {
  mounted() {

    if (document.querySelector(".news-featured")) {
      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".news-featured",
          start: "0% 80%",
          end: "0% 80%",
          toggleActions: 'play none reverse none',
        },
      }).to(".news-featured li", {
        duration: 1,
        width: '100%',
        stagger: 0.1
      }).to(".news-featured li a .title", {
        duration: 1.25,
        opacity: '1',
      }).to(".news-featured li a .date", {
        duration: 1.25,
        opacity: '1',
      });


      // gsap.to('.news-featured li', {
      //   scrollTrigger: {
      //     trigger: ".news-featured",
      //     start: "0% 80%",
      //     end: "0% 80%",
      //     toggleActions: 'play none reverse none',
      //   },
      //   duration: 1.25,
      //   width: '100%',
      //   stagger: 0.1
      // });
    }

    gsap.utils.toArray("[data-parallax]").forEach(element => {
      gsap.to(element, {
        scrollTrigger: {
          scrub: 2,
          // invalidateOnRefresh: true
        },
        yPercent: (i, target) => element.dataset.parallax,
        ease: "none"
      });
    });
  }
}